/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Notice_DescriptionInputs */

const en_directory_promotion_notice_description = /** @type {(inputs: Directory_Promotion_Notice_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These values help define the UI. They are not live inventory or a payment offer.`)
};

const zh_directory_promotion_notice_description = /** @type {(inputs: Directory_Promotion_Notice_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些数值用于确定 UI，并不代表实时库存或付款报价。`)
};

/**
* | output |
* | --- |
* | "These values help define the UI. They are not live inventory or a payment offer." |
*
* @param {Directory_Promotion_Notice_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_notice_description = /** @type {((inputs?: Directory_Promotion_Notice_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Notice_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_notice_description(inputs)
	return zh_directory_promotion_notice_description(inputs)
});
export { directory_promotion_notice_description as "directory.promotion.notice_description" }